// Customer-side JS entry chain. Converted from CJS `require()` to ESM
// `import` during the Stage 4 Webpacker → Vite migration: esbuild does
// not transform `require` in files that already use top-level ESM
// `import`, so the legacy `require()` calls below would throw
// `ReferenceError: require is not defined` in the browser otherwise.

// MUST stay first — installs window.jQuery / window.$ during the ESM
// import phase, before any legacy library import (timber, swipe, etc.)
// that depends on jQuery being on the global object.
import './_jquery_setup'

// Populates window.imagesLoaded / window.Isotope + wires jquery-bridget
// during the import phase — template-functions.js reads
// `window.imagesLoaded` at import time so the assignment must precede it.
import './_libs_setup'

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"

import './libraries/jquery-ui-1.10.3'

import './libraries/swipe'
import './libraries/timber'
// import './libraries/avalanche'
import './libraries/summit'
import './libraries/snowbridge'
import './libraries/horizon'
import './libraries/retinize'
import './libraries/equalize'
import './libraries/counter'
// import './libraries/preloadpage'
import './libraries/freeze'

import './libraries/fluidvids-2.4.1'
import './libraries/placeholder-2.3.1'
// import './libraries/mediaelement-4.2.9'
// import './libraries/mediaelement-and-player-4.2.9'
import './libraries/datepicker'
import './libraries/iziModal'
import './libraries/template-functions'

import './libraries/toastr'

import './libraries/cookieconsent'


import './custom_modules/address_validation.js'
import './custom_modules/contact_form.js'
import './custom_modules/form_validator.js'
import './custom_modules/prototype_functions.js'
import './custom_modules/templates.js'

import './bulk_form.js'
import './checkout.js'
import './configurator.js'
import './contact_support.js'
import './contact_us.js'
import './framework.js'
import './request_box.js'
import './select_offer.js'
import './static_pages.js'
import './user_edit.js'

import '../Actioncable/cable'

// Module body runs after all imports resolve.
//
// @rails/ujs 6.1's compiled bundle has an auto-init block at the end:
//   if (window.Rails === Rails && fire(document, 'rails:attachBindings')) {
//     Rails.start();
//   }
// Under Webpacker each pack was wrapped in its own CommonJS scope where
// `this.Rails = ...` did NOT touch window, so the auto-init branch was
// never taken and an explicit `Rails.start()` was required. Vite's CJS
// interop binds `this` to the global object, so `window.Rails` IS set
// during import and the auto-init fires once on its own. The unguarded
// `Rails.start()` then ran a second time and threw
//   "rails-ujs has already been loaded!"
// from rails-ujs.js:714, crashing the customer_side entry chain.
// Guard against the second call via the same flag UJS uses internally.
if (!window._rails_loaded) {
  Rails.start()
}
Turbolinks.start()
